import { buildFacetDesignOverrideLite, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { FDHeadlineText } from '@facet-wealth/design';

export default buildFacetDesignOverrideLite()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly);
